import React from 'react'
import MallProduct from '../DarazMall/MallProduct'
import "./daramall.css"
import {useNavigate} from "react-router-dom"
import { malldata } from './mallproductdata';

function DarazMall() {
  const navigate = useNavigate();
  return (
    <div className='mall-container'>
        <div className='mall-one'>
            <h3>Daraz Mall</h3>
            <p onClick={()=> navigate('/saleproduct')}>SHOP MORE {">"}</p>
        </div>
        <div>
            <MallProduct  malldata={malldata} key={malldata.id} />
        </div>
    </div>
  )
}

export default DarazMall